// Fix this file, do not use any as the type
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Get } from 'config/apiServiceConfig'

export const getTotalOrderCount = (locationId: any): any =>
  Get({ url: `/api/order/count?location_id=${locationId}` })
export const getOrderPartialConfirmed = (locationId: any): any =>
  Get({ url: `api/order/partial-confirmed/${locationId}` })
